export const mockData = {
  searchSuggestions: {
    city: [
      'Melbourne, VIC',
      'Sydney, NSW',
      'Brisbane, QLD',
      'Perth, WA',
      'Adelaide, SA',
      'Canberra, ACT',
      'Gold Coast, QLD',
      'Newcastle, NSW',
      'Wollongong, NSW',
      'Darwin, NT'
    ],
    university: [
      // New South Wales
      'University of Sydney', 'University of New South Wales (UNSW)', 'University of Technology Sydney (UTS)',
      'Macquarie University', 'University of Newcastle', 'University of Wollongong',
      'Western Sydney University', 'Australian Catholic University', 'Southern Cross University',
      // Victoria
      'University of Melbourne', 'Monash University', 'RMIT University', 'Deakin University',
      'La Trobe University', 'Swinburne University of Technology', 'Victoria University',
      'Federation University Australia',
      // Queensland
      'University of Queensland', 'Queensland University of Technology (QUT)', 'Griffith University',
      'James Cook University', 'University of the Sunshine Coast', 'Central Queensland University',
      'Bond University', 'University of Southern Queensland',
      // Western Australia
      'University of Western Australia', 'Curtin University', 'Murdoch University', 'Edith Cowan University',
      // South Australia
      'University of Adelaide', 'University of South Australia (UniSA)', 'Flinders University',
      // ACT
      'Australian National University (ANU)', 'University of Canberra',
      // Tasmania
      'University of Tasmania',
      // Northern Territory
      'Charles Darwin University',
      // TAFEs & Colleges
      'TAFE NSW', 'TAFE Victoria', 'TAFE Queensland', 'TAFE SA', 'North Metropolitan TAFE',
      'Holmesglen Institute', 'Box Hill Institute', 'RMIT TAFE', 'William Angliss Institute',
      'Melbourne Polytechnic', 'Chisholm Institute', 'Gordon Institute of TAFE',
      'TAFE Gippsland', 'Bendigo Kangan Institute', 'Sunraysia Institute of TAFE',
    ],
    property: [
      'Scape Student Living',
      'Iglu Student Accommodation',
      'UniLodge',
      'Urbanest',
      'Student One',
      'Homestay Families',
      'Campus Living Villages',
      'Journal Student Living',
      'Atira Student Living',
      'YourSpace Student Living'
    ]
  },

  quickFilters: [
    'Melbourne', 'Sydney', 'Brisbane', 'Perth', 'University of Melbourne', 'UNSW', 'UQ', 'Scape'
  ],

  popularCities: [
    {
      id: 1,
      name: 'Melbourne',
      country: 'Australia',
      properties: 189,
      startingPrice: 'A$380',
      image: 'https://images.pexels.com/photos/33263106/pexels-photo-33263106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      universities: ['University of Melbourne', 'RMIT', 'Monash University']
    },
    {
      id: 2,
      name: 'Sydney',
      country: 'Australia', 
      properties: 245,
      startingPrice: 'A$420',
      image: 'https://images.pexels.com/photos/1035725/pexels-photo-1035725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      universities: ['University of Sydney', 'UNSW', 'UTS']
    },
    {
      id: 3,
      name: 'Brisbane',
      country: 'Australia',
      properties: 156,
      startingPrice: 'A$350',
      image: 'https://images.pexels.com/photos/2590144/pexels-photo-2590144.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      universities: ['University of Queensland', 'QUT', 'Griffith University']
    },
    {
      id: 4,
      name: 'Perth',
      country: 'Australia',
      properties: 98,
      startingPrice: 'A$320',
      image: 'https://images.pexels.com/photos/35355651/pexels-photo-35355651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      universities: ['University of Western Australia', 'Curtin', 'Murdoch']
    },
    {
      id: 5,
      name: 'Adelaide',
      country: 'Australia',
      properties: 87,
      startingPrice: 'A$290',
      image: 'https://images.unsplash.com/photo-1544984243-ec57ea16fe25?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      universities: ['University of Adelaide', 'UniSA', 'Flinders University']
    },
    {
      id: 6,
      name: 'Canberra',
      country: 'Australia',
      properties: 76,
      startingPrice: 'A$340',
      image: 'https://images.pexels.com/photos/12532604/pexels-photo-12532604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      universities: ['Australian National University', 'University of Canberra', 'ADFA']
    }
  ],

  featuredProperties: [
    {
      id: 1,
      name: 'Scape Melbourne Central',
      location: 'Melbourne, VIC',
      price: 'A$450',
      period: 'week',
      rating: 4.8,
      reviews: 156,
      image: 'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/5f947de211ed84c6d44c7f5792628ccfb16eef012bd21893dbd12da5b60d346d.png',
      amenities: ['WiFi', 'Gym', 'Study Hub', 'Rooftop Terrace'],
      roomTypes: ['Studio', 'En-suite', 'Twin Share'],
      walkingDistance: '3 min to RMIT',
      description: 'Premium purpose-built student accommodation in the heart of Melbourne CBD. Features a stunning rooftop terrace with city views, state-of-the-art gym, and dedicated study hubs — everything you need for a great student life.'
    },
    {
      id: 2,
      name: 'Iglu Sydney Central',
      location: 'Sydney, NSW',
      price: 'A$520',
      period: 'week',
      rating: 4.9,
      reviews: 203,
      image: 'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/6652849e0d0716f019183f29fd4dabc34eaf8a0beb146c8b1bf8d923463ad65d.png',
      amenities: ['WiFi', 'Gym', 'Cinema Room', 'Laundry'],
      roomTypes: ['Studio', 'En-suite', '2-bed'],
      walkingDistance: '8 min to UTS',
      description: 'Iglu Sydney Central offers modern, fully furnished rooms steps from UTS and the vibrant Sydney CBD. Enjoy the private cinema room, social events, and fast fibre WiFi included in your rent.'
    },
    {
      id: 3,
      name: 'UniLodge Brisbane',
      location: 'Brisbane, QLD',
      price: 'A$380',
      period: 'week',
      rating: 4.7,
      reviews: 142,
      image: 'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/1b65da443f5e5fd0e09a62254978dff2ba9524dcaaf093a541cab451da0e6cae.png',
      amenities: ['WiFi', 'Pool', 'BBQ Area', 'Study Rooms'],
      roomTypes: ['Shared', 'En-suite', 'Studio'],
      walkingDistance: '10 min to UQ',
      description: 'UniLodge Brisbane is perfectly located near UQ and QUT. Relax by the resort-style pool, host a BBQ with friends, or focus in one of the dedicated study rooms — all with fast WiFi included.'
    },
    {
      id: 4,
      name: 'Scape Perth',
      location: 'Perth, WA',
      price: 'A$350',
      period: 'week',
      rating: 4.6,
      reviews: 98,
      image: 'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/981154cd6a5755d9ed6c3e7578b130648a176b85780ebc47c86b7a38133bb976.png',
      amenities: ['WiFi', 'Gym', 'Courtyard', 'Security'],
      roomTypes: ['Studio', 'En-suite', 'Twin Share'],
      walkingDistance: '15 min to UWA',
      description: 'Scape Perth puts you close to UWA and Curtin University with modern en-suite rooms, a vibrant social courtyard, and 24/7 security. All bills and fast WiFi included in weekly rent.'
    },
    {
      id: 5,
      name: 'Urbanest Adelaide',
      location: 'Adelaide, SA',
      price: 'A$320',
      period: 'week',
      rating: 4.5,
      reviews: 76,
      image: 'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/ed1b133f2aa4bcff0f8163ca9231d83dc3abf253a7e92675f02d60168f54b135.png',
      amenities: ['WiFi', 'Common Lounge', 'Kitchen', 'Laundry'],
      roomTypes: ['Shared', 'En-suite', 'Studio'],
      walkingDistance: '5 min to University of Adelaide',
      description: 'Urbanest Adelaide is a short walk from the University of Adelaide campus. Comfortable en-suite rooms, fully-equipped shared kitchens, and a welcoming common lounge make it the ideal home away from home.'
    },
    {
      id: 6,
      name: 'Homestay Melbourne',
      location: 'Melbourne, VIC',
      price: 'A$280',
      period: 'week',
      rating: 4.4,
      reviews: 65,
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      amenities: ['WiFi', 'Meals Included', 'Family Environment', 'Study Space'],
      roomTypes: ['Single Room', 'Shared Room', 'En-suite'],
      walkingDistance: '20 min to University of Melbourne',
      description: 'Experience authentic Australian family life with Homestay Melbourne. Meals, WiFi, and a quiet study space are included. Ideal for students seeking a supportive, safe, and warm home environment.'
    }
  ],

  testimonials: [
    {
      id: 1,
      name: 'Emma Wilson',
      university: 'University of Melbourne',
      location: 'Melbourne, VIC',
      rating: 5,
      text: 'RentalX made finding accommodation in Melbourne so easy! Their team was incredibly helpful and I found my perfect studio at Scape Melbourne Central within days. The verification process gave me complete peace of mind.',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
      property: 'Scape Melbourne Central'
    },
    {
      id: 2,
      name: 'James Chen',
      university: 'UNSW Sydney',
      location: 'Sydney, NSW',
      rating: 5,
      text: 'Amazing service from start to finish. The 24/7 support really helped when I had questions about my lease at Iglu Sydney Central. Couldn\'t be happier with my accommodation choice!',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
      property: 'Iglu Sydney Central'
    },
    {
      id: 3,
      name: 'Sarah Thompson',
      university: 'University of Queensland',
      location: 'Brisbane, QLD',
      rating: 5,
      text: 'The booking process was seamless and the price guarantee saved me over A$300! The property exceeded my expectations and the location is perfect for campus access.',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
      property: 'UniLodge Brisbane'
    },
    {
      id: 4,
      name: 'Michael Davis',
      university: 'University of Western Australia',
      location: 'Perth, WA',
      rating: 4,
      text: 'Great platform with lots of options across Australia. The virtual tours were really helpful since I was booking from interstate. Highly recommend RentalX for Australian students.',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
      property: 'Scape Perth'
    }
  ],

  stats: {
    totalStudents: '50,000+',
    totalProperties: '1,000+',
    totalCities: '100+',
    averageRating: '4.8',
    totalReviews: '12,500+'
  }
};